<template>
    <v-container v-if="show" id="footer" class="footer-wrapper" fluid>
        <v-row column justify-center align-center no-gutters>
            <v-col cols="12">
                <v-container>
                    <v-row column justify-center align-center class="text-left">
                        <v-col
                            cols="12"
                            md="9"
                            class="footer-column footer-column--left"
                        >
                            <MenuFooterProducts
                                :menu="menuFooterProducts"
                                :steez="`footer`"
                                class=""
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="3"
                            class="footer-column footer-column--right"
                        >
                            <MenuFooterServices
                                :menu="menuFooterServices"
                                :steez="`footer`"
                                class=""
                            />
                            <!-- TODO: Improve this ContentAddress component -->
                            <ContentAddress />
                            <!-- <div id="payment-method-icons">
                                <div>
                                    <EmbedSanityImage
                                        :originalFilename="'visa-white.png'"
                                       :alt="{en: 'Visa', es:'Visa'}"
                                        width="40"
                                        height="25"
                                        classes="footer-icons"
                                    />
                                </div>
                                <div>
                                    <EmbedSanityImage
                                        :originalFilename="'mastercard-white.png'"
                                        :alt="{en: 'Mastercard', es:'Mastercard'}"
                                        width="40"
                                        height="25"
                                        classes="footer-icons"
                                    />
                                </div>
                                <div>
                                    <EmbedSanityImage
                                        :originalFilename="'discover-white.png'"
                                        :alt="{en: 'Discover', es:'Discover'}"
                                        width="40"
                                        height="25"
                                        classes="footer-icons"
                                    />
                                </div>
                                <div>
                                    <EmbedSanityImage
                                        :originalFilename="'amex-white.png'"
                                       :alt="{en: 'Amex', es:'Amex'}"
                                        width="40"
                                        height="25"
                                        classes="footer-icons"
                                    />
                                </div>
                                <div>
                                    <EmbedSanityImage
                                        :originalFilename="'purchase-order-white.png'"
                                        :alt="{en: 'Purchase Order', es:'Purchase Order'}"
                                        width="55"
                                        height="25"
                                        classes="footer-icons custom-footer-class"
                                    />
                                </div>
                            </div> -->
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ContentAddress from '~/components/ContentAddress.vue'
import MenuFooterProducts from '~/components/menus/MenuFooterProducts.vue'
import MenuFooterServices from '~/components/menus/MenuFooterServices.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'

export default {
    name: 'Footer',
    components: {
        ContentAddress,
        MenuFooterProducts,
        MenuFooterServices,
        EmbedSanityImage,
    },
    props: {
        show: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            menuFooterProducts: this.$store.state.common.footerProducts,
            menuFooterServices: this.$store.state.common.footerServices,
        }
    },
}
</script>
